import React, { useState } from 'react';
import Context from './index';

const SearchResultProvider = (props) => {
    const [tabsData] = useState([]);

    return (
        <Context.Provider
            value={{
                ...props,
                tabsData
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default SearchResultProvider;
